import React from 'react';

const SvgChat = props => (
  <svg width={19} height={19} {...props}>
    <path
      d="M16.218 2.785A9.444 9.444 0 0 1 19 9.504a9.435 9.435 0 0 1-2.782 6.715A9.437 9.437 0 0 1 9.499 19a9.516 9.516 0 0 1-4.501-1.13c-1.023.704-2.25 1.106-3.415 1.106-.235 0-.462-.02-.673-.052a.882.882 0 0 1-.74-.744.89.89 0 0 1 .485-.926c.57-.279 1.071-.86 1.497-1.731-3.085-3.747-2.834-9.277.629-12.738A9.441 9.441 0 0 1 9.499 0c2.54 0 4.924.99 6.719 2.785zm-.76 12.67c3.287-3.282 3.287-8.628 0-11.918A8.375 8.375 0 0 0 9.499 1.07a8.375 8.375 0 0 0-5.958 2.467c-3.144 3.142-3.3 8.21-.354 11.536a.54.54 0 0 1 .091.573c-.45 1.03-.987 1.77-1.628 2.248.538-.012 1.764-.151 2.982-1.094a.56.56 0 0 1 .33-.111c.091 0 .187.027.27.075A8.428 8.428 0 0 0 9.5 17.922a8.375 8.375 0 0 0 5.959-2.467zM13.465 6c.293 0 .535.222.535.5s-.238.5-.535.5h-7.93C5.238 7 5 6.778 5 6.5s.238-.5.535-.5h7.93zm0 3c.293 0 .535.222.535.5s-.238.5-.535.5h-7.93C5.238 10 5 9.778 5 9.5s.238-.5.535-.5h7.93zm0 3c.293 0 .535.222.535.5s-.238.5-.535.5h-7.93C5.238 13 5 12.778 5 12.5s.238-.5.535-.5h7.93z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgChat;
